// extracted by mini-css-extract-plugin
export default {"container":"h-z","wrapper":"i-z","hideCartCount":"j-z","heading":"k-z","items":"l-z","side":"m-z","checkoutWrapper":"n-z","legal":"o-z","fitNotRecommended":"p-z","fitCallout":"q-z"};